import fetchHotelAvailabilities from 'js/apiCalls/hotelAvailabilities'
import setValue from 'js/components/shared/actions/setValue'

import {searchResults, decreasingBanner} from "js/components/shared/drupalSettings";
import {serializeParameter} from 'js/url/utils';

export const SEARCH_PARAM_TO_ROOM_RATES = 'toRoomRates';

export default () => async (dispatch, getState) => {
  const state = getState();
  const {queryString, parameters} = state.url;
  // api v3 request url
  // create formdata needed for axios request
  const formData = new FormData()
  const params = new URLSearchParams(queryString || window.location.search)
  const data = searchResults
  data.brand_statement = Array.isArray(data.brand_statement) ? data.brand_statement : []
  data.decreasingBanner = decreasingBanner;
  const { dataLayer: _dl, ...dataWithoutDL } = data
  dispatch(setValue(false, dataWithoutDL))

  if (parameters.dateIn && parameters.nbNight) {
    const roomsParams = parameters.apartment
    roomsParams.forEach((room) => {
      const r = serializeParameter('apartment', [room]);
      formData.append('params[apartment[]]', r);
    })

    const paramsV3 = {
      dateIn: serializeParameter('dateIn', parameters.dateIn),
      nights: serializeParameter('nbNight', parameters.nbNight || '1'),
      price_range: serializeParameter('priceRange', parameters.priceRange),
      amenities: serializeParameter('amenities', parameters.amenities),
      hotel_type: serializeParameter('hotelType', parameters.hotelType),
      sort: serializeParameter('sort', parameters.sort),
    };

    // append params to formdata
    Object.entries(paramsV3).forEach(
      ([key, value]) => {
        formData.append(`params[${key}]`, value)
      },
    )
    // get ids of received hotels
    const hotelIds = data.results.map(item => item.id)
    // append hotels id to formdata
    hotelIds.forEach((item) => {
      formData.append('hotelsCodes[]', item)
    })


    // send request to get hot data from v3
    const response = await fetchHotelAvailabilities(formData)
    // add received data from v3 to correspond by Id
    // if only one hotel go to room rates
    if (!response?.data?.availabilities?.length) return // if no data from request
    if (response.data.availabilities.length === 1 && response.data.availabilities[0].available === true) {
      const resultsDS = window?.drupalSettings?.searchResults?.results ?? null
      const linkToRoomRates = resultsDS[0].reserveBtnUrl
      if (params.has(SEARCH_PARAM_TO_ROOM_RATES) && linkToRoomRates !== null) {
        // remove to Room rates query
        params.delete(SEARCH_PARAM_TO_ROOM_RATES)
        window.history.replaceState({}, '', `?${params.toString()}`)
        window.location = linkToRoomRates
      } else if (params.has(SEARCH_PARAM_TO_ROOM_RATES)) {
        // remove to Room rates query
        params.delete(SEARCH_PARAM_TO_ROOM_RATES)
        window.history.replaceState({}, '', `?${params.toString()}`)
      }
    } else {
      // creating deep copy of data to force react rerender component
      // when redux state changed
      const deepCopyData = JSON.parse(JSON.stringify(data))
      deepCopyData.results.forEach((itemV2, iV2) => {
        response.data.availabilities.forEach((itemV3, iV3) => {
          // eslint-disable-next-line max-len
          if (String(deepCopyData.results[iV2].id) === String(response.data.availabilities[iV3].id)) {
            deepCopyData.results[iV2] = {
              ...deepCopyData.results[iV2],
              ...response.data.availabilities[iV3],
              isConnected: response.data.isConnected,
            }
          }
        })
      })

      // move not available items to the bottom of list
      const available = deepCopyData.results.filter(r => r.available === true)
      const notAvailable = deepCopyData.results.filter(r => r.available === false)
      deepCopyData.results = available.concat(notAvailable)
      const { dataLayer: _dl2, ...deepCopyWithoutDL } = deepCopyData
      dispatch(setValue(false, deepCopyWithoutDL))
    }
  }
}
